<script>
import { IonButton } from '@ionic/vue'

export default IonButton
</script>
